var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoObank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 983.3 411.6",
    style: {
      enableBackground: "new 0 0 983.3 411.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6007E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_2_",
    className: "st0",
    d: "M610.9,0h372.4v344.3H754.2l20-34.7l-102.1,102v-67.3h-61.1V0z M924.2,216.2l3.7-142.3 h-36.4l3.7,142.3H924.2z M892.9,270.4h33.6v-33.5h-33.6V270.4z M669.6,172.2c0,50.2,33.2,100.5,99,100.7 c65.7,0,98.2-50.4,98.2-100.7c0-50.3-32.6-100.7-98.6-100.7C702.8,71.7,669.6,121.9,669.6,172.2z M769,104.5l0.4,0 c41.4,0,61.8,33.3,61.8,66.5c0,33.2-20.4,66.5-61.8,66.5l-0.4,0c-41.1-0.2-62.3-33.4-62.3-66.5C706.7,137.9,727.8,104.7,769,104.5z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.3,73.5l56.8,150.9l56.6-150.9H202v196.9h-34.1v-64.9l3.4-86.8l-58.1,151.7H88.7l-58-151.6l3.4,86.7v64.9H0V73.5H44.3z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.1,195.9c0-14.3,2.8-27.2,8.5-38.7c5.7-11.5,13.6-20.3,23.9-26.5c10.3-6.2,22.1-9.3,35.4-9.3 c19.7,0,35.8,6.4,48.1,19.1C361.3,153.2,368,170,369,191l0.1,7.7c0,14.4-2.8,27.3-8.3,38.7c-5.5,11.4-13.5,20.1-23.8,26.4 c-10.3,6.2-22.2,9.3-35.8,9.3c-20.6,0-37.2-6.9-49.5-20.6c-12.4-13.7-18.6-32.1-18.6-55V195.9z M265.9,198.7 c0,15.1,3.1,26.8,9.3,35.4c6.2,8.5,14.9,12.8,26,12.8c11.1,0,19.7-4.3,25.9-13c6.2-8.7,9.3-21.3,9.3-38c0-14.8-3.2-26.5-9.5-35.2 c-6.4-8.7-15-13-25.9-13c-10.7,0-19.3,4.3-25.6,12.8C269.1,169.1,265.9,181.8,265.9,198.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.2,124.1h32.7v146.3h-32.7v-97.6l-57.3,97.6h-32.7V124.1h32.7v97.6L488.2,124.1z M503.6,68c0,11.4-4,20.6-11.9,27.6 c-7.9,7-18.5,10.5-31.8,10.5c-13.2,0-23.8-3.5-31.8-10.5S416.3,79.3,416.3,68h24.6c0,5.9,1.7,10.4,5.1,13.7c3.4,3.2,8,4.9,14,4.9 c5.9,0,10.6-1.6,13.9-4.9c3.3-3.2,5-7.8,5-13.7H503.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoObank);
export default __webpack_public_path__ + "static/media/logo-obank.eda709b138ae7e9da0aa28d08fefc9b1.svg";
export { ForwardRef as ReactComponent };